// Sidebar nav icons. Each is a single theme-adaptive SVG vendored from
// design-system/icons by sync-design-system.mjs: stroke="currentColor"
// plus a self-contained `svg:hover` animation. They're INLINED (not
// <img>) so the stroke tracks the nav link's text colour across the
// default / hover / active states, and the baked-in animation can play.
// Decorative — the adjacent text label names the destination — so the
// wrapper is aria-hidden.
import dashboard from "./icons/dashboard-gauge.svg?raw";
import watchlist from "./icons/watchlist-eye.svg?raw";
import companies from "./icons/company-search.svg?raw";
import ai from "./icons/ai-sparkle.svg?raw";
import apikeys from "./icons/apikeys-key.svg?raw";
import usage from "./icons/usage-chart.svg?raw";
import billing from "./icons/billing-card.svg?raw";

const ICONS = {
  dashboard,
  watchlist,
  companies,
  ai,
  apikeys,
  usage,
  billing,
} as const;

export type NavIconName = keyof typeof ICONS;

export function NavIcon({ name }: { name: NavIconName }) {
  return (
    <span
      className="nav-icon"
      aria-hidden
      dangerouslySetInnerHTML={{ __html: ICONS[name] }}
    />
  );
}
